import type { MarketSelectorValue } from '../types';

/**
 * Builds the Market Selector value shape for explicit market/account selections.
 *
 * Use this when the selections are not backed by an aggregation preset. Keeping this helper small
 * avoids ad hoc `{ type: 'custom', selections }` objects drifting across market-selector callers.
 */
export function toMarketSelectorValue(selections: string[]): MarketSelectorValue {
  return {
    type: 'custom',
    selections,
  };
}
